import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/admin/login', { email, password });
      localStorage.setItem('admin_token', res.data.token);
      toast.success('Angemeldet');
      navigate('/admin');
    } catch {
      toast.error('Ungültige Anmeldedaten');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0A0A0B]" data-testid="admin-login-page">
      <div className="animate-fade-up bg-[#121214] border border-white/5 rounded-2xl p-8 max-w-sm w-full">
        <div className="text-center mb-8">
          <div className="w-12 h-12 mx-auto rounded-full bg-[#3B82F6]/15 flex items-center justify-center mb-4">
            <Lock className="w-6 h-6 text-[#3B82F6]" />
          </div>
          <h1 className="font-outfit font-bold text-2xl text-white">Admin Login</h1>
          <p className="text-[#9CA3AF] text-sm mt-1">IT-Quiz Verwaltung</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <Label className="text-[#9CA3AF] text-xs">E-Mail</Label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)}
              className="bg-white/5 border-white/10 text-white mt-1" data-testid="admin-email" />
          </div>
          <div>
            <Label className="text-[#9CA3AF] text-xs">Passwort</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="bg-white/5 border-white/10 text-white mt-1" data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-outfit font-bold rounded-lg" data-testid="admin-login-btn">
            {loading ? 'Anmelden...' : 'Anmelden'}
          </Button>
        </form>
      </div>
    </div>
  );
}
